export { default as ConfigPageLayout } from './configPageLayout';
